/* ============================================================
   BULIER — comportamenti comuni a tutto il sito.
   Tradotto da mockup/comune.js il 28 settembre 2026.

   Qui sta solo cio' che vale ovunque: la testata che si stringe
   scorrendo e i pannelli che si aprono dalla testata.
   ============================================================ */
(function(){
  'use strict';

  const testata = document.querySelector('.testata');
  if(!testata) return;

  /* ---------- dove finisce la testata ----------
     Finisce in --h-testata perche' i pannelli partono subito sotto.

     Si misura il BORDO INFERIORE, non l'altezza: sopra la testata puo'
     esserci la fascia degli annunci, e con la sola altezza la prima riga
     del menu finiva nascosta dietro il logo. Il bordo inferiore tiene
     conto da solo di qualunque cosa stia sopra, e cambia quando la
     fascia scorre via. */
  let ultimaMisura = -1, ultimaAltezza = -1;
  function misura(){
    const r = testata.getBoundingClientRect();

    /* --h-testata: DOVE FINISCE la testata adesso. Serve ai pannelli,
       che devono partire subito sotto. Cambia mentre si scorre, perche'
       la fascia degli annunci se ne va: e' giusto che cambi. */
    const giu = Math.max(0, Math.round(r.bottom));
    if(giu !== ultimaMisura){
      ultimaMisura = giu;
      document.documentElement.style.setProperty('--h-testata', giu + 'px');
    }

    /* --testata-altezza: QUANT'E' ALTA la testata. Non cambia mai
       scorrendo. Serve a chi calcola un'altezza fissa, come la galleria
       della scheda prodotto: usando la misura di sopra, la fotografia
       cresceva di 400px mentre si scorreva la pagina. */
    const alta = Math.round(r.height);
    if(alta !== ultimaAltezza && alta > 0){
      ultimaAltezza = alta;
      document.documentElement.style.setProperty('--testata-altezza', alta + 'px');
    }
  }
  misura();
  if(window.ResizeObserver) new ResizeObserver(misura).observe(testata);
  addEventListener('resize', misura);

  /* ---------- il logotipo lascia il centro al monogramma ----------
     Solo sulle pagine interne, dove la testata ha la classe --marchio.
     Una sola lettura per fotogramma: lo scorrimento non deve pagare
     un ricalcolo di stile a ogni evento. */
  if(testata.classList.contains('testata--marchio')){
    let inCoda = false;
    const aggiorna = () => {
      testata.classList.toggle('ridotta', window.scrollY > 70);
      misura();
      inCoda = false;
    };
    addEventListener('scroll', () => {
      if(!inCoda){ inCoda = true; requestAnimationFrame(aggiorna); }
    }, {passive:true});
    aggiorna();
  }

  /* ---------- i pannelli ----------
     Il markup lo stampa Liquid, qui c'e' solo l'apertura. I comandi
     stanno in tre posti diversi — il burger, la voce "Menu" del
     computer, la barra in basso del telefono — ma aprono la stessa
     cosa: si agganciano con data-apre. */
  const oscura   = document.querySelector('.oscura');
  const pannelli = {
    menu:  document.querySelector('.lastra--menu'),
    cerca: document.querySelector('.lastra--cerca')
  };

  /* col mouse il menu si apre passandoci sopra; col dito no, perche'
     sul telefono "passare sopra" non esiste */
  const colMouse = () => matchMedia('(hover:hover) and (min-width:901px)').matches;

  let aperto = null;

  function apri(nome){
    const p = pannelli[nome];
    if(!p) return;
    misura();
    if(aperto === nome){ chiudi(); return; }

    Object.keys(pannelli).forEach(k => {
      const q = pannelli[k];
      if(!q) return;
      const attivo = k === nome;
      q.classList.toggle('aperta', attivo);
      /* inert, non hidden: hidden mette display:none e la transizione
         non parte. Cosi' il pannello chiuso resta irraggiungibile da
         tastiera ma puo' ancora sfumare. */
      if(attivo) q.removeAttribute('inert'); else q.setAttribute('inert','');
    });

    if(oscura) oscura.classList.add('aperta');

    /* il menu col mouse non blocca lo scorrimento: si apre sfiorandolo,
       e una pagina che si inchioda perche' hai passato il puntatore
       sopra una voce e' una pagina rotta */
    if(!(nome === 'menu' && colMouse())) document.body.style.overflow = 'hidden';

    aperto = nome;
    segnalaBurger(true);
    document.dispatchEvent(new CustomEvent('bulier:apre', {detail:{pannello:nome}}));
  }

  function chiudi(){
    Object.keys(pannelli).forEach(k => {
      const q = pannelli[k];
      if(!q) return;
      q.classList.remove('aperta');
      q.setAttribute('inert','');
    });
    if(oscura) oscura.classList.remove('aperta');
    document.body.style.overflow = '';
    aperto = null;
    segnalaBurger(false);
  }

  function segnalaBurger(stato){
    const b = document.querySelector('.burger');
    if(b) b.setAttribute('aria-expanded', stato ? 'true' : 'false');
  }

  document.querySelectorAll('[data-apre]').forEach(nodo => {
    nodo.addEventListener('click', e => {
      const nome = nodo.getAttribute('data-apre');
      if(!pannelli[nome]) return;           /* non c'e' ancora: lascia
                                               andare il link vero */
      e.preventDefault();
      /* se e' gia' aperto perche' ci sei passato sopra col mouse, il
         clic non deve richiuderlo: sarebbe un dispetto */
      if(nome === 'menu' && colMouse() && aperto === 'menu') return;
      apri(nome);
    });
  });

  const burger = document.querySelector('.burger');
  if(burger) burger.addEventListener('click', e => { e.preventDefault(); apri('menu'); });

  document.querySelectorAll('[data-chiude]').forEach(n => n.addEventListener('click', chiudi));
  addEventListener('keydown', e => { if(e.key === 'Escape' && aperto) chiudi(); });

  /* ============================================================
     LA RICERCA
     Il mockup leggeva un file con 103 prodotti congelati. Qui si usa la
     ricerca vera di Shopify: mentre si scrive si chiede al negozio il
     pezzo di pagina gia' disegnato dalla sezione bulier-ricerca-esiti.
     Cosi' i prezzi, le foto e le giacenze sono sempre quelli veri e non
     c'e' nessun catalogo da tenere aggiornato.
     ============================================================ */
  (function(){
    const pannello = pannelli.cerca;
    if(!pannello) return;

    const campo   = pannello.querySelector('[data-cerca-campo]');
    const esiti   = pannello.querySelector('[data-cerca-esiti]');
    const aiuto   = pannello.querySelector('[data-cerca-aiuto]');
    const pulisci = pannello.querySelector('[data-cerca-pulisci]');
    if(!campo || !esiti) return;

    let attesa, annulla;

    /* il campo prende il fuoco quando il pannello si apre, ma solo dopo
       che e' comparso: dare il fuoco a un elemento che sta ancora
       sfumando fa saltare la pagina in su */
    document.addEventListener('bulier:apre', e => {
      if(e.detail.pannello === 'cerca') setTimeout(() => campo.focus(), 120);
    });

    function svuota(){
      esiti.innerHTML = '';
      if(aiuto) aiuto.hidden = false;
      if(pulisci) pulisci.hidden = true;
    }

    function cerca(){
      const q = campo.value.trim();
      if(pulisci) pulisci.hidden = !campo.value;
      if(q.length < 2){ svuota(); return; }
      if(aiuto) aiuto.hidden = true;

      /* una richiesta alla volta: senza questo, una risposta lenta
         partita prima puo' arrivare dopo e sovrascrivere quella giusta */
      if(annulla) annulla.abort();
      annulla = new AbortController();

      const url = '/search/suggest?q=' + encodeURIComponent(q)
                + '&section_id=bulier-ricerca-esiti'
                + '&resources[type]=product&resources[limit]=10';

      fetch(url, {signal: annulla.signal})
        .then(r => r.ok ? r.text() : Promise.reject(r.status))
        .then(html => { esiti.innerHTML = html; })
        .catch(err => { if(err !== 20 && err.name !== 'AbortError') esiti.innerHTML = ''; });
    }

    campo.addEventListener('input', () => {
      clearTimeout(attesa);
      attesa = setTimeout(cerca, 220);   /* si aspetta che smetta di scrivere */
    });

    if(pulisci) pulisci.addEventListener('click', () => {
      campo.value = ''; svuota(); campo.focus();
    });

    /* Esc: prima svuota il campo, e solo se e' gia' vuoto chiude il
       pannello. Chiudere tutto al primo Esc, dopo che uno ha scritto,
       e' un dispetto. */
    campo.addEventListener('keydown', e => {
      if(e.key === 'Escape' && campo.value){ e.stopPropagation(); campo.value=''; svuota(); }
    });

    pannello.querySelectorAll('[data-cerca-suggerita]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        campo.value = a.getAttribute('data-cerca-suggerita');
        campo.focus();
        cerca();
      });
    });
  })();

  /* ============================================================
     I PANNELLI DELLE PAGINE (filtri, ordinamento)
     Non sono le lastre della testata: questi coprono anche la testata,
     perche' sono una scelta a tutto schermo. Stessa logica di apertura,
     scritta qui una volta per tutte le pagine che ne avranno.
     ============================================================ */
  (function(){
    const apribili = document.querySelectorAll('[data-apre-pannello]');
    if(!apribili.length) return;

    let apertoPag = null;

    function chiudiPag(){
      if(!apertoPag) return;
      apertoPag.classList.remove('aperto');
      apertoPag.setAttribute('inert','');
      document.querySelectorAll('[data-apre-pannello]').forEach(b => b.setAttribute('aria-expanded','false'));
      document.body.style.overflow = '';
      apertoPag = null;
    }

    function apriPag(id){
      const p = document.getElementById(id);
      if(!p) return;
      if(apertoPag === p){ chiudiPag(); return; }
      chiudiPag();
      p.classList.add('aperto');
      p.removeAttribute('inert');
      document.querySelectorAll('[data-apre-pannello="' + id + '"]')
        .forEach(b => b.setAttribute('aria-expanded','true'));
      /* su telefono il pannello e' a tutto schermo: la pagina sotto non
         deve scorrere. Su computer e' una colonna laterale e lo scorrimento
         resta, altrimenti la pagina salta appena si apre un filtro. */
      if(matchMedia('(max-width:900px)').matches) document.body.style.overflow = 'hidden';
      apertoPag = p;
    }

    apribili.forEach(b => b.addEventListener('click', e => {
      e.preventDefault();
      apriPag(b.getAttribute('data-apre-pannello'));
    }));

    document.querySelectorAll('[data-chiudi-pannello]').forEach(b =>
      b.addEventListener('click', chiudiPag));

    addEventListener('keydown', e => { if(e.key === 'Escape') chiudiPag(); });

    /* toccare fuori chiude, ma non se si tocca dentro il pannello o sul
       comando che lo ha aperto */
    document.addEventListener('click', e => {
      if(!apertoPag) return;
      if(apertoPag.contains(e.target)) return;
      if(e.target.closest('[data-apre-pannello]')) return;
      chiudiPag();
    });

    /* i pannelli partono chiusi anche prima che arrivi il JS */
    document.querySelectorAll('.pannello').forEach(p => p.setAttribute('inert',''));
  })();

  /* ============================================================
     COLLEZIONE: campioni colore e selettore rapido della taglia
     ============================================================ */
  (function(){
    /* Si ascolta sul documento e non su UNA griglia: in una pagina ce ne
       puo' essere piu' d'una — i risultati di ricerca e "Ti potrebbe
       piacere" sotto la scheda prodotto — e prendendo solo la prima le
       altre restavano morte. */
    /* anche nel carrello: "Completa il look" usa lo stesso foglio delle
       taglie per i capi con piu' taglie (Andrea, 05/10/2026) */
    if(!document.querySelector('.griglia') && !document.querySelector('[data-rapido]')) return;

    /* ---- il campione cambia la foto, il prezzo e il collegamento ----
       senza ricaricare e senza entrare nella scheda */
    document.addEventListener('click', e => {
      const campione = e.target.closest('.colore--foto');
      if(!campione) return;
      /* Solo i campioni dentro una scheda della griglia. Quelli della
         scheda prodotto sono link veri a un altro colore: bloccandoli
         il clic sul colore non portava da nessuna parte. */
      const capo = campione.closest('[data-capo]');
      if(!capo) return;
      e.preventDefault();

      capo.querySelectorAll('.colore--foto').forEach(c => c.setAttribute('aria-pressed','false'));
      campione.setAttribute('aria-pressed','true');

      const foto    = capo.querySelector('[data-capo-foto]');
      const link    = capo.querySelector('[data-capo-link]');
      const prezzo  = capo.querySelector('[data-capo-prezzo]');
      const prima   = capo.querySelector('[data-capo-prima]');
      const rapido  = capo.querySelector('[data-rapido]');

      const nuovaFoto = campione.getAttribute('data-colore-foto');
      if(foto && nuovaFoto){
        foto.removeAttribute('srcset');   /* altrimenti il srcset vecchio vince */
        foto.src = nuovaFoto;
      }
      if(link)   link.href = campione.getAttribute('data-colore-url');
      if(prezzo) prezzo.textContent = campione.getAttribute('data-colore-prezzo');
      if(prima){
        const p = campione.getAttribute('data-colore-prima');
        prima.textContent = p || '';
        prima.hidden = !p;
      }
      capo.dataset.handle = campione.getAttribute('data-colore-handle');
      if(rapido) rapido.setAttribute('data-rapido', campione.getAttribute('data-colore-handle'));
    });

    /* ---- il selettore rapido ---- */
    const foglio = document.getElementById('bulierFoglio');
    const velo   = document.querySelector('.velo');
    if(!foglio) return;

    let ultimoComando = null;

    function chiudiFoglio(){
      foglio.classList.remove('aperto');
      foglio.setAttribute('inert','');
      if(velo) velo.classList.remove('aperto');
      document.body.style.overflow = '';
      if(ultimoComando) ultimoComando.focus();
    }

    async function apriFoglio(handle, comando){
      ultimoComando = comando || null;
      foglio.innerHTML = '<div class="foglio__carico">Un momento&hellip;</div>';
      foglio.classList.add('aperto');
      foglio.removeAttribute('inert');
      if(velo) velo.classList.add('aperto');
      document.body.style.overflow = 'hidden';
      /* il fuoco va al foglio, non al pulsante di chiusura: il browser
         disegnerebbe il suo anello azzurro proprio sulla x */
      foglio.focus();

      try{
        const r = await fetch('/products/' + handle + '?section_id=bulier-taglie');
        if(!r.ok) throw new Error(r.status);
        foglio.innerHTML = await r.text();
        preparaFoglio();
      }catch(err){
        foglio.innerHTML = '<div class="foglio__carico">Non riesco a caricare le taglie. '
          + '<a href="/products/' + handle + '">Apri la scheda del capo</a>.</div>';
      }
    }

    function preparaFoglio(){
      const taglie   = foglio.querySelectorAll('.taglia');
      const rimaste  = foglio.querySelector('[data-foglio-rimaste]');
      const campoId  = foglio.querySelector('[data-foglio-id]');
      const aggiungi = foglio.querySelector('[data-foglio-aggiungi]');

      taglie.forEach(t => t.addEventListener('click', () => {
        if(t.disabled) return;
        taglie.forEach(x => x.setAttribute('aria-pressed','false'));
        t.setAttribute('aria-pressed','true');
        if(campoId) campoId.value = t.getAttribute('data-variante');
        const pre = window.bulierPreordine(t);
        if(aggiungi){ aggiungi.disabled = false; aggiungi.textContent = pre ? 'Preordina' : 'Aggiungi al carrello'; }
        if(rimaste && pre){ rimaste.textContent = pre.testo; return; }
        if(rimaste){
          const n = parseInt(t.getAttribute('data-rimaste'), 10);
          /* si avvisa solo quando ne restano pochi: "ne restano 47" non
             fa comprare nessuno, "ne resta uno" si */
          rimaste.textContent = (n > 0 && n <= 3)
            ? (n === 1 ? 'Ne resta uno' : 'Ne restano ' + n)
            : '';
        }
      }));

      /* se c'e' una sola taglia comprabile, e' gia' scelta: un tocco in meno */
      const comprabili = [...taglie].filter(t => !t.disabled);
      if(comprabili.length === 1) comprabili[0].click();

      foglio.querySelectorAll('[data-foglio-chiudi]').forEach(b =>
        b.addEventListener('click', chiudiFoglio));

      /* Aggiunta al carrello senza cambiare pagina. La form resta una
         form vera che punta a /cart/add: se il JavaScript non parte,
         aggiunge lo stesso e porta al carrello. Qui la intercettiamo
         solo per restare dove si era. */
      const form = foglio.querySelector('[data-foglio-form]');
      if(form) form.addEventListener('submit', async e => {
        e.preventDefault();
        if(!aggiungi || aggiungi.disabled) return;
        const etichetta = aggiungi.textContent;
        aggiungi.disabled = true;
        aggiungi.textContent = 'Aggiungo\u2026';
        try{
          const r = await fetch('/cart/add.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({ items:[Object.assign({ id: campoId.value, quantity: 1 }, (function(){ const t = foglio.querySelector('.taglia[aria-pressed="true"]'); const pre = window.bulierPreordine(t); return pre ? { properties: pre.proprieta } : {}; })())] })
          });
          if(!r.ok){
            const errore = await r.json().catch(() => null);
            throw new Error(errore && errore.description ? errore.description : 'errore');
          }
          await aggiornaCarrello();
          aggiungi.textContent = 'Aggiunto';
          /* nel carrello la riga nuova e il totale si vedono solo ricaricando */
          if(document.querySelector('[data-carrello-form]')){ setTimeout(() => location.reload(), 500); return; }
          setTimeout(chiudiFoglio, 700);
        }catch(err){
          aggiungi.disabled = false;
          aggiungi.textContent = etichetta;
          const avviso = foglio.querySelector('[data-foglio-rimaste]');
          if(avviso) avviso.textContent = 'Non sono riuscito ad aggiungerlo. Riprova.';
        }
      });
    }

    /* il numero nella testata e nella barra del telefono: sta in fondo
       al file, fuori da qui, perche' lo chiamano in due — il selettore
       rapido della taglia e la pagina del look. Due copie prima o poi
       si contraddicono. */
    const aggiornaCarrello = () => window.bulierAggiornaCarrello();

    document.addEventListener('click', e => {
      const b = e.target.closest('[data-rapido]');
      if(!b) return;
      e.preventDefault();
      apriFoglio(b.getAttribute('data-rapido'), b);
    });

    if(velo) velo.addEventListener('click', chiudiFoglio);
    addEventListener('keydown', e => {
      if(e.key === 'Escape' && foglio.classList.contains('aperto')) chiudiFoglio();
    });
  })();

  /* ============================================================
     SCHEDA PRODOTTO
     ============================================================ */
  /* PREORDINE / IN ARRIVO (05/10/2026): la taglia porta tipo e nota
     (data-pre-tipo, data-pre-nota). Nel carrello e nell'ordine finisce:
     una riga visibile "Preordine: Spedito dal 20 ottobre" e una nascosta
     _bulier_attesa = tipo, che SEMPLIFY legge per tenere l'ordine in
     attesa e mettere il tag. */
  window.bulierPreordine = function(t){
    const tipo = t && t.getAttribute('data-pre-tipo');
    if(!tipo) return null;
    const nota = t.getAttribute('data-pre-nota') || (tipo === 'In arrivo' ? 'te lo spediamo appena arriva' : 'te lo spediamo appena pronto');
    const proprieta = {}; proprieta[tipo] = nota; proprieta._bulier_attesa = tipo;
    return { tipo, nota, testo: tipo + ': ' + nota.charAt(0).toLowerCase() + nota.slice(1), proprieta };
  };
  /* ---- carrello, "Completa il look": aggiunta in un tocco per i capi
     con una sola taglia; poi si ricarica il carrello (righe e totale) ---- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-aggiungi-subito]');
    if(!b) return;
    e.preventDefault();
    if(b.disabled) return;
    const etichetta = b.textContent;
    b.disabled = true; b.textContent = 'Aggiungo\u2026';
    try{
      const r = await fetch('/cart/add.js', { method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items:[{ id: +b.getAttribute('data-aggiungi-subito'), quantity: 1 }] }) });
      if(!r.ok) throw new Error(r.status);
      b.textContent = 'Aggiunto';
      location.reload();
    }catch(err){
      b.disabled = false; b.textContent = etichetta;
    }
  });

  (function(){
    /* ---- carrello, telefono: la barra "vai al checkout" in basso c'e'
       da subito e si toglie solo quando il pulsante vero del conto e' in
       vista, per non averne due uguali (Andrea, 05/10/2026). Prima non
       compariva mai: nessuno le metteva "visibile". ---- */
    const barraCassa = document.querySelector('[data-barra-cassa]');
    const cassaVera = document.querySelector('[data-cassa-vera]');
    if(barraCassa && cassaVera && 'IntersectionObserver' in window){
      new IntersectionObserver(([voce]) => {
        barraCassa.classList.toggle('visibile', !voce.isIntersecting);
      }, { rootMargin: '0px 0px -96px 0px', threshold: 0 }).observe(cassaVera);
    }

  })();

  (function(){
    const taglie = document.querySelector('[data-taglie]');
    if(!taglie) return;

    const bottoni  = taglie.querySelectorAll('.taglia');
    const rimaste  = document.querySelector('[data-avviso-taglia]');
    const campoId  = document.querySelector('[data-variante-scelta]');
    const aggiungi = document.querySelector('[data-aggiungi]');
    const form     = document.querySelector('[data-form-acquisto]');
    const avvisami = document.querySelector('[data-avvisami]');
    let scelta = null;

    function scegli(b){
      if(b.disabled) return;
      bottoni.forEach(x => x.setAttribute('aria-pressed','false'));
      b.setAttribute('aria-pressed','true');
      scelta = b;
      const stato = b.getAttribute('data-stato');

      if(campoId) campoId.value = b.getAttribute('data-variante');

      /* "Avvisami" e "Aggiungi" non convivono: o si compra o si aspetta */
      const daAvvisare = stato === 'avvisami';
      if(avvisami) avvisami.hidden = !daAvvisare;
      if(form) form.hidden = daAvvisare;

      if(aggiungi && !daAvvisare){
        aggiungi.disabled = false;
        aggiungi.textContent = stato === 'preordine' ? 'Preordina' : 'Aggiungi al carrello';
      }

      /* sul preordine non vale "Consegna in 1-4 giorni": le righe di servizio
         segnate si nascondono (05/10/2026) */
      document.querySelectorAll('.servizio[data-no-preordine]').forEach(r => r.hidden = stato === 'preordine');

      if(rimaste){
        const n = parseInt(b.getAttribute('data-rimaste'), 10);
        if(stato === 'preordine'){
          const pre = window.bulierPreordine(b);
          rimaste.textContent = pre ? pre.testo : '';
        }else if(stato === 'normale' && n > 0 && n <= 3){
          rimaste.textContent = n === 1 ? 'Ne resta uno' : 'Ne restano ' + n;
        }else{
          rimaste.textContent = '';
        }
      }

      const prezzo = b.getAttribute('data-prezzo');
      if(prezzo) document.querySelectorAll('[data-prezzo-mostrato]').forEach(n => {
        const vecchio = n.querySelector('.scheda__prima');
        n.textContent = prezzo;
        if(vecchio) n.appendChild(vecchio);
      });
    }

    bottoni.forEach(b => b.addEventListener('click', () => scegli(b)));

    /* se c'e' una sola taglia comprabile e' gia' scelta: un tocco in meno.
       Vale anche per i capi a taglia unica, che sono tanti fra gli accessori. */
    const comprabili = [...bottoni].filter(b => !b.disabled && b.getAttribute('data-stato') !== 'avvisami');
    if(comprabili.length === 1) scegli(comprabili[0]);

    /* ---- la galleria ---- */
    const galleria = document.getElementById('galleria');
    if(galleria){
      const foto = [...galleria.children];
      const mini = document.querySelectorAll('[data-mini]');
      const vai = i => {
        const n = Math.max(0, Math.min(foto.length - 1, i));
        galleria.scrollTo({ left: n * galleria.clientWidth, behavior: 'smooth' });
        mini.forEach((m,k) => m.setAttribute('aria-pressed', k === n ? 'true' : 'false'));
      };
      const dove = () => Math.round(galleria.scrollLeft / Math.max(1, galleria.clientWidth));
      const pre = document.querySelector('[data-foto-prima]');
      const dop = document.querySelector('[data-foto-dopo]');
      if(pre) pre.addEventListener('click', () => vai(dove() - 1));
      if(dop) dop.addEventListener('click', () => vai(dove() + 1));
      mini.forEach(m => m.addEventListener('click', () => vai(+m.getAttribute('data-mini'))));
      galleria.addEventListener('scroll', () => {
        const n = dove();
        mini.forEach((m,k) => m.setAttribute('aria-pressed', k === n ? 'true' : 'false'));
      }, {passive:true});
    }

    /* ---- la barra del telefono compare quando serve ----
       Non e' sempre in vista: si accende solo quando il pulsante vero e'
       uscito dallo schermo. Averla sempre addosso ruba spazio alle foto,
       che sono il motivo per cui si sta su questa pagina. */
    const barra = document.querySelector('[data-barra-acquisto]');
    const bottoneVero = document.querySelector('[data-aggiungi]');
    if(barra && bottoneVero && 'IntersectionObserver' in window){
      new IntersectionObserver(([voce]) => {
        barra.classList.toggle('visibile', !voce.isIntersecting);
      }, { rootMargin: '0px 0px -96px 0px', threshold: 0 }).observe(bottoneVero);
    }

    /* ---- la barra del telefono porta alle taglie ---- */
    const vaiTaglie = document.querySelector('[data-vai-taglie]');
    if(vaiTaglie) vaiTaglie.addEventListener('click', () => {
      taglie.scrollIntoView({behavior:'smooth', block:'center'});
      const primo = [...bottoni].find(b => !b.disabled);
      if(primo) primo.focus();
    });

    /* ---- aggiunta al carrello senza cambiare pagina ---- */
    if(form) form.addEventListener('submit', async e => {
      e.preventDefault();
      if(!scelta || !aggiungi || aggiungi.disabled) return;
      const etichetta = aggiungi.textContent;
      aggiungi.disabled = true;
      aggiungi.textContent = 'Aggiungo\u2026';
      try{
        const r = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[Object.assign({ id: campoId.value, quantity: 1 }, (window.bulierPreordine(scelta) ? { properties: window.bulierPreordine(scelta).proprieta } : {}))] })
        });
        if(!r.ok) throw new Error('no');
        const c = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-carrello]').forEach(n => n.textContent = 'Carrello (' + c.item_count + ')');
        document.querySelectorAll('[data-carrello-numero]').forEach(n => n.textContent = c.item_count);
        aggiungi.textContent = 'Aggiunto';
        setTimeout(() => { aggiungi.disabled = false; aggiungi.textContent = etichetta; }, 1400);
      }catch(err){
        aggiungi.disabled = false;
        aggiungi.textContent = etichetta;
        if(rimaste) rimaste.textContent = 'Non sono riuscito ad aggiungerlo. Riprova.';
      }
    });

    /* ---- avvisami quando torna ----
       Passa da Klaviyo, che e' gia' il programma delle email. Senza il
       codice impostato il modulo non finge di funzionare: lo dice. */
    const formAvviso = document.querySelector('[data-avvisami-form]');
    const esito = document.querySelector('[data-avvisami-esito]');
    if(formAvviso) formAvviso.addEventListener('submit', async e => {
      e.preventDefault();
      const chiave = formAvviso.closest('[data-avvisami]').getAttribute('data-klaviyo');
      if(!chiave){
        if(esito) esito.textContent = 'Gli avvisi non sono ancora collegati. Scrivici e ti avvisiamo a mano.';
        return;
      }
      if(!scelta) return;
      const dati = new URLSearchParams({
        a: chiave,
        email: formAvviso.email.value,
        variant: scelta.getAttribute('data-variante'),
        platform: 'shopify'
      });
      if(esito) esito.textContent = 'Un momento\u2026';
      try{
        const r = await fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
          method:'POST',
          headers:{'Content-Type':'application/x-www-form-urlencoded'},
          body: dati.toString()
        });
        if(!r.ok) throw new Error('no');
        if(esito) esito.textContent = 'Fatto. Ti scrivo appena torna.';
        formAvviso.reset();
      }catch(err){
        if(esito) esito.textContent = 'Non ha funzionato. Riprova o scrivici.';
      }
    });
  })();

  /* ---- la home: la testata galleggia sul video ---- */
  (function(){
    const apertura = document.getElementById('apertura');
    if(!apertura) return;

    /* quanto e' alta la fascia degli annunci: la testata si mette
       esattamente sotto. A mano sarebbe sbagliata il giorno che quel
       testo va a capo — e sul telefono ci va. */
    const gruppo = [...document.querySelectorAll('.shopify-section-group-header-group')]
      .filter(n => !n.classList.contains('bulier-testata'));
    const misuraAnnuncio = () => {
      const h = gruppo.reduce((somma, n) => somma + n.getBoundingClientRect().height, 0);
      document.documentElement.style.setProperty('--h-annuncio', Math.round(h) + 'px');
    };
    misuraAnnuncio();
    if(window.ResizeObserver && gruppo.length){
      const ro = new ResizeObserver(misuraAnnuncio);
      gruppo.forEach(n => ro.observe(n));
    }
    addEventListener('resize', misuraAnnuncio);

    /* Il logotipo non sparisce di colpo: rimpicciolisce mentre scorri.
       Resta grande per il primo terzo del video, poi si stringe e si
       completa esattamente quando il video finisce. --avanzamento va da
       0 a 1 e lo legge il CSS. Solo su computer: sul telefono il
       logotipo e' gia' piccolo e l'effetto sarebbe uno sfarfallio. */
    const radice = document.documentElement;
    const soloComputer = () => matchMedia('(min-width:1025px)').matches;
    let inCoda = false;
    function avanzamento(){
      inCoda = false;
      if(!soloComputer()){
        radice.style.removeProperty('--avanzamento');
        radice.style.removeProperty('--logo-colore');
        return;
      }
      const H = apertura.offsetHeight;
      const inizio = H * 0.35;
      const g = Math.min(1, Math.max(0, (scrollY - inizio) / Math.max(1, H - inizio)));
      /* parte piano e finisce piano: un rimpicciolimento lineare si vede
         partire di scatto */
      const e = g < 0.5 ? 2*g*g : 1 - Math.pow(-2*g + 2, 2) / 2;
      radice.style.setProperty('--avanzamento', e.toFixed(4));
      const c = Math.round(255 + (20 - 255) * e);
      radice.style.setProperty('--logo-colore', 'rgb(' + c + ',' + c + ',' + c + ')');
    }
    addEventListener('scroll', () => { if(!inCoda){ inCoda = true; requestAnimationFrame(avanzamento); } }, {passive:true});
    addEventListener('resize', avanzamento);
    avanzamento();

    if(!('IntersectionObserver' in window)) return;
    new IntersectionObserver(([voce]) => {
      document.body.classList.toggle('oltre-apertura', !voce.isIntersecting);
    }, { rootMargin: '-90px 0px 0px 0px', threshold: 0 }).observe(apertura);
  })();

  /* ---- il foglio dei vantaggi del programma fedelta ---- */
  (function(){
    const tessere = document.querySelectorAll('[data-livello]');
    const foglio  = document.getElementById('foglioLivello');
    if(!tessere.length || !foglio) return;

    const nome   = foglio.querySelector('#flNome');
    const sconto = foglio.querySelector('#flSconto');
    const soglia = foglio.querySelector('#flSoglia');
    const lista  = foglio.querySelector('#flLista');
    let chiTocco = null;

    function apri(t){
      chiTocco = t;
      nome.textContent = t.getAttribute('data-nome');
      /* il nome nel foglio porta lo stesso metallo della tessera */
      nome.className = 'foglio-livello__nome livello--' + t.getAttribute('data-metallo');
      sconto.textContent = t.getAttribute('data-sconto');
      soglia.textContent = t.getAttribute('data-soglia');
      lista.innerHTML = '';
      (t.getAttribute('data-vantaggi') || '').split('\n')
        .map(r => r.trim()).filter(Boolean)
        .forEach(r => { const li = document.createElement('li'); li.textContent = r; lista.appendChild(li); });
      foglio.classList.add('aperto');
      foglio.removeAttribute('inert');
      /* il fuoco va al foglio, non alla x: il browser disegnerebbe il
         suo anello azzurro proprio sul pulsante di chiusura */
      foglio.focus();
      document.body.style.overflow = 'hidden';
    }

    function chiudi(){
      foglio.classList.remove('aperto');
      foglio.setAttribute('inert','');
      document.body.style.overflow = '';
      if(chiTocco) chiTocco.focus();
    }

    tessere.forEach(t => t.addEventListener('click', () => apri(t)));
    foglio.querySelectorAll('[data-livello-chiudi]').forEach(b => b.addEventListener('click', chiudi));
    addEventListener('keydown', e => { if(e.key === 'Escape' && foglio.classList.contains('aperto')) chiudi(); });
    document.addEventListener('click', e => {
      if(!foglio.classList.contains('aperto')) return;
      if(foglio.contains(e.target) || e.target.closest('[data-livello]')) return;
      chiudi();
    });
  })();

  /* ---- pagine di testo: l'indice si costruisce dai titoli ---- */
  (function(){
    const testo  = document.querySelector('[data-testo]');
    const indice = document.querySelector('[data-indice]');
    if(!testo || !indice) return;

    const titoli = [...testo.querySelectorAll('h2')];
    /* con meno di due titoli un indice e' rumore: si toglie da solo */
    if(titoli.length < 2){ indice.remove(); return; }

    const lista = indice.querySelector('ol');
    const senzaAccenti = t => t.toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-')
      .replace(/^-+|-+$/g,'').slice(0,50);

    const voci = titoli.map((h, i) => {
      /* chi scrive in amministrazione non mette gli id: glieli diamo noi,
         ricavandoli dal titolo cosi' l'indirizzo resta leggibile */
      if(!h.id) h.id = senzaAccenti(h.textContent) || ('sezione-' + (i+1));
      const li = document.createElement('li');
      const a  = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a); lista.appendChild(li);
      return {h, a};
    });

    /* sotto i 1200px l'indice diventa un pannello richiudibile, chiuso:
       su schermo stretto una colonna in piu' mangia meta' del testo */
    const stretto = matchMedia('(max-width:1200px)');
    const adatta = () => { indice.open = !stretto.matches; };
    adatta();
    stretto.addEventListener('change', adatta);

    /* segna dove sei: si accende l'ultimo titolo passato sotto la testata */
    if(!('IntersectionObserver' in window)) return;
    let attivo = null;
    const segna = v => {
      if(attivo === v) return;
      voci.forEach(x => x.a.removeAttribute('aria-current'));
      if(v) v.a.setAttribute('aria-current','true');
      attivo = v;
    };
    const osserva = new IntersectionObserver(righe => {
      righe.forEach(r => {
        if(r.isIntersecting){
          segna(voci.find(x => x.h === r.target));
        }
      });
    }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
    voci.forEach(x => osserva.observe(x.h));
  })();

  /* ============================================================
     I CAPI ARRIVANO MENTRE SI SCENDE
     Niente "pagina 2", niente "precedenti": si scende e basta. Il
     collegamento vero resta nel markup per Google e per chi non ha il
     JavaScript; qui lo nascondiamo e ci pensiamo noi.

     Si carica UNA pagina per volta e solo quando il fondo si avvicina:
     tirarne giu' cinque insieme farebbe scaricare mezzo catalogo a chi
     magari voleva solo arrivare al footer.
     ============================================================ */
  (function(){
    const zona = document.querySelector('[data-altri]');
    const griglia = document.querySelector('.griglia');
    if(!zona || !griglia || !('IntersectionObserver' in window)) return;

    const link   = zona.querySelector('.altri__link');
    const attesa = zona.querySelector('.altri__attesa');
    if(link) link.hidden = true;

    let sto = false;
    /* Quante pagine si sono caricate da quando la cliente ha scorso
       l'ultima volta. Senza questo freno, finche' la zona resta in
       fondo allo schermo il caricamento si richiama da solo e tira giu'
       mezzo catalogo in un colpo: provato, una scorsa sola portava 148
       schede. Due per volta bastano a non far vedere il fondo. */
    let giri = 0;
    addEventListener('scroll', () => { giri = 0; }, {passive:true});

    async function porta(){
      const prossima = zona.getAttribute('data-prossima');
      if(sto || !prossima) return;
      sto = true;
      if(attesa) attesa.hidden = false;

      try{
        const r = await fetch(prossima);
        if(!r.ok) throw new Error(r.status);
        const doc = new DOMParser().parseFromString(await r.text(), 'text/html');

        const nuovi = doc.querySelectorAll('.griglia .capo');
        nuovi.forEach(n => griglia.appendChild(n));

        const altra = doc.querySelector('[data-altri]');
        if(altra && altra.getAttribute('data-prossima')){
          zona.setAttribute('data-prossima', altra.getAttribute('data-prossima'));
        }else{
          /* finiti: si toglie la zona e, se la pagina nuova aveva la riga
             di chiusura, la si porta qui */
          const fine = doc.querySelector('[data-fine]');
          if(fine) zona.parentNode.insertBefore(fine, zona);
          osserva.disconnect();
          zona.remove();
          return;
        }
      }catch(err){
        /* se qualcosa va storto si rimette il collegamento vero: meglio
           un clic in piu' che una collezione che finisce a meta' */
        if(link) link.hidden = false;
        osserva.disconnect();
      }finally{
        sto = false;
        if(attesa) attesa.hidden = true;
      }

      /* Il rilevatore scatta solo quando l'elemento ENTRA nello schermo.
         Se dopo aver caricato resta dentro — succede in fondo alla
         pagina, o su uno schermo alto — non scatterebbe mai piu' e il
         caricamento si fermerebbe da solo. Quindi dopo ogni giro si
         guarda se serve ancora, e nel caso si continua. */
      giri += 1;
      if(giri < 2 && vicino()) setTimeout(porta, 120);
    }

    const vicino = () => {
      if(!zona.isConnected) return false;
      return zona.getBoundingClientRect().top < window.innerHeight + 600;
    };

    /* 600px prima del fondo: i capi sono gia' li' quando ci arrivi */
    const osserva = new IntersectionObserver(righe => {
      if(righe.some(r => r.isIntersecting)) porta();
    }, { rootMargin: '600px 0px' });
    osserva.observe(zona);
  })();

  /* Apertura col mouse, solo su computer. La pastiglia con "Menu" e il
     pannello si comportano come una cosa sola: si esce da una per
     entrare nell'altro senza che sparisca. Il ritardo di un quinto di
     secondo serve a quel passaggio, e a non far lampeggiare il menu se
     il puntatore lo attraversa per sbaglio. */
  let ritardo;
  [testata.querySelector('.testata__sx'), pannelli.menu].filter(Boolean).forEach(zona => {
    zona.addEventListener('mouseenter', () => {
      if(!colMouse()) return;
      clearTimeout(ritardo);
      if(aperto !== 'menu') apri('menu');
    });
    zona.addEventListener('mouseleave', () => {
      if(!colMouse()) return;
      clearTimeout(ritardo);
      ritardo = setTimeout(() => { if(aperto === 'menu') chiudi(); }, 200);
    });
  });
})();

/* ============================================================
   IL NUMERO DEL CARRELLO
   Nella testata e nella barra del telefono ce n'e' uno solo, e si
   aggiorna da qui. Sta fuori dai blocchi perche' lo chiamano in due:
   il selettore rapido della taglia e la pagina "Scegli il tuo look".
   ============================================================ */
window.bulierAggiornaCarrello = async function(){
  try{
    const r = await fetch('/cart.js');
    const c = await r.json();
    document.querySelectorAll('[data-carrello]').forEach(n => {
      n.textContent = 'Carrello (' + c.item_count + ')';
    });
    document.querySelectorAll('[data-carrello-numero]').forEach(n => {
      n.textContent = c.item_count;
    });
  }catch(e){ /* il contatore sbagliato non vale una pagina rotta */ }
};

/* ============================================================
   SCEGLI IL TUO LOOK
   Tradotto da mockup/look.html. Due modi nella stessa pagina: i look
   proposti (stampati da Liquid, qui si aggiungono e basta) e il
   compositore, dove la cliente sceglie e sposta i capi.

   NIENTE VINCOLI DI CATEGORIA, come deciso: ci sono sei posizioni
   sulla tavola e ci va quello che vuole, nell'ordine che vuole. I
   filtri servono a TROVARE un capo, non a decidere dove finisce.

   LE TAGLIE SI CHIEDONO ALLA FINE, in un foglio solo, una riga per
   capo: chiederle a ogni capo aggiunto spezzerebbe la parte bella,
   che e' comporre.
   ============================================================ */
(function(){
  const radice = document.querySelector('[data-look]');
  if(!radice) return;

  const fonte = radice.querySelector('[data-look-capi]');
  const CAPI = {};
  try{
    JSON.parse(fonte.textContent).forEach(c => { CAPI[c.h] = c; });
  }catch(e){ return; }   /* senza dati la pagina resta quella stampata da Liquid */

  const MAX = Number(radice.dataset.massimo) || 6;

  /* le stesse sei posizioni del foglio di stile, qui in numeri: servono
     come punto di partenza quando un capo arriva sulla tavola, prima
     che venga spostato */
  const LAYOUT = [
    {l:26, t:31, w:48, h:62},
    {l:0,  t:11, w:42, h:38},
    {l:59, t:3,  w:40, h:33},
    {l:68, t:43, w:32, h:27},
    {l:2,  t:55, w:22, h:20},
    {l:31, t:0,  w:26, h:16},
  ];

  /* dove sta ogni capo sulla tavola, in percentuale: cosi' la posizione
     resta giusta anche quando la tavola cambia dimensione */
  const dove = new Map();
  let davanti = 1;

  const scelti = [];                       /* handle dei capi sulla tavola */
  const tavola  = radice.querySelector('[data-tavola]');
  const catalogo = radice.querySelector('[data-catalogo]');
  const cerca   = radice.querySelector('[data-cerca]');

  /* I PREZZI SI SCRIVONO COME LI SCRIVE IL NEGOZIO.
     Il totale e' l'unico prezzo calcolato qui: tutti gli altri
     arrivano gia' formattati da Liquid. Scriverlo a mano "109,00 EUR"
     lo faceva stonare con il resto del sito, e su un altro mercato
     sarebbe stato proprio sbagliato. Quindi si usa il formato vero
     del negozio, quello di shop.money_format. */
  const formato = radice.dataset.soldi || '{{amount_with_comma_separator}}';

  function cifre(centesimi, chiave){
    const virgola = chiave.indexOf('comma_separator') !== -1;   /* 1.234,56 */
    const interi  = chiave.indexOf('no_decimals') !== -1;
    const n = centesimi / 100;
    const s = interi ? String(Math.round(n)) : n.toFixed(2);
    const pezzi = s.split('.');
    pezzi[0] = pezzi[0].replace(/\B(?=(\d{3})+(?!\d))/g, virgola ? '.' : ',');
    return pezzi.length > 1 ? pezzi[0] + (virgola ? ',' : '.') + pezzi[1] : pezzi[0];
  }

  const soldi = centesimi =>
    formato.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, chiave){ return cifre(centesimi, chiave); });
  const pulisci = s => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'')
                        .replace(/\s+/g,' ').trim();

  /* ---------- le due linguette ---------- */
  function mostraModo(nome){
    const scelto = [...radice.querySelectorAll('.modi button')].find(x => x.dataset.modo === nome);
    if(!scelto) return false;
    radice.querySelectorAll('.modi button').forEach(x =>
      x.setAttribute('aria-selected', String(x === scelto)));
    radice.querySelectorAll('.modo').forEach(s => s.hidden = s.dataset.modo !== nome);
    return true;
  }

  radice.querySelectorAll('.modi button').forEach(b => {
    b.addEventListener('click', () => {
      mostraModo(b.dataset.modo);
      /* L'indirizzo segue la linguetta, cosi' il collegamento si puo'
         mandare a qualcuno e si apre dove ci si aspetta. replaceState
         e non hash diretto: altrimenti ogni linguetta lascia una tappa
         nella cronologia e il tasto indietro non esce piu' dalla
         pagina. */
      if(history.replaceState) history.replaceState(null, '', '#' + b.dataset.modo);
    });
  });

  /* Dal menu si arriva gia' sulla linguetta giusta: /pages/...#tuo */
  const daUrl = () => (location.hash || '').replace('#', '');
  if(daUrl()) mostraModo(daUrl());
  addEventListener('hashchange', () => { if(daUrl()) mostraModo(daUrl()); });

  /* ---------- la tavola del compositore ---------- */
  function disegnaTavola(){
    if(!tavola) return;
    if(!scelti.length){
      tavola.innerHTML = '<div class="tavola--vuota"><p>' +
        (radice.dataset.vuota || 'Scegli un capo dall’elenco. Poi spostalo dove vuoi: la tavola è tua.') +
        '</p></div>';
      return;
    }
    tavola.innerHTML = scelti.slice(0, MAX).map((h, n) => {
      const c = CAPI[h];
      if(!dove.has(h)) dove.set(h, Object.assign({}, LAYOUT[n], {z: ++davanti}));
      const d = dove.get(h);
      const stile = 'left:' + d.l + '%;top:' + d.t + '%;width:' + d.w + '%;height:' + d.h + '%;z-index:' + d.z;
      const foto = c.r || c.f;
      return '<div class="posto ' + (c.r ? 'posto--ritaglio' : 'posto--foto') + '"' +
             ' data-handle="' + h + '" style="' + stile + '">' +
               '<img src="' + foto + '" alt="' + c.n + '">' +
               '<button class="togli" type="button" data-togli="' + h + '" aria-label="Togli ' + c.n + '">&times;</button>' +
             '</div>';
    }).join('');
  }

  function disegna(){
    disegnaTavola();

    const rimetti = radice.querySelector('[data-rimetti]');
    if(rimetti) rimetti.hidden = scelti.length === 0;

    const totale = scelti.reduce((s, h) => s + CAPI[h].pn, 0);
    const nTot = radice.querySelector('[data-totale]');
    const nQua = radice.querySelector('[data-quanti]');
    const nAgg = radice.querySelector('[data-aggiungi-tutto]');
    const nPie = radice.querySelector('[data-pieno]');
    if(nTot) nTot.textContent = scelti.length ? soldi(totale) : '\u2014';
    if(nQua) nQua.textContent = scelti.length === 0 ? 'nessun capo scelto'
      : scelti.length === 1 ? '1 capo scelto' : scelti.length + ' capi scelti';
    if(nAgg) nAgg.disabled = scelti.length === 0;
    if(nPie) nPie.hidden = scelti.length < MAX;

    /* la ricerca e il filtro di categoria si sommano: se cerchi "nero"
       dentro Borse, restano le borse nere */
    const q = cerca ? pulisci(cerca.value) : '';
    let visti = 0;
    radice.querySelectorAll('.capo-scelta').forEach(b => {
      b.setAttribute('aria-pressed', String(scelti.includes(b.dataset.capoHandle)));
      const perCategoria = !filtro || b.dataset.cat === filtro;
      const perNome = !q || pulisci(b.dataset.cerca).includes(q);
      b.hidden = !(perCategoria && perNome);
      if(!b.hidden) visti++;
    });

    const esito = radice.querySelector('[data-esito]');
    if(esito){
      if(!q){ esito.textContent = ''; esito.hidden = true; }
      else {
        esito.hidden = false;
        esito.textContent = visti === 0 ? 'Nessun capo per \u201c' + cerca.value.trim() + '\u201d'
          : visti === 1 ? '1 capo' : visti + ' capi';
      }
    }
  }

  let filtro = '';

  function commuta(h){
    const p = scelti.indexOf(h);
    if(p >= 0){ scelti.splice(p, 1); dove.delete(h); dimentica(h); }
    else if(scelti.length < MAX) scelti.push(h);
    disegna();
  }

  if(catalogo) catalogo.addEventListener('click', e => {
    const b = e.target.closest('.capo-scelta');
    if(b) commuta(b.dataset.capoHandle);
  });
  if(tavola) tavola.addEventListener('click', e => {
    const b = e.target.closest('.togli');
    if(b) commuta(b.dataset.togli);
  });
  const nFiltri = radice.querySelector('[data-filtri]');
  if(nFiltri) nFiltri.addEventListener('click', e => {
    const b = e.target.closest('button');
    if(!b) return;
    filtro = b.dataset.cat;
    nFiltri.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    disegna();
  });
  if(cerca){
    cerca.addEventListener('input', disegna);
    cerca.addEventListener('keydown', e => {
      if(e.key === 'Escape'){ e.target.value = ''; disegna(); }
    });
  }
  const nRimetti = radice.querySelector('[data-rimetti]');
  if(nRimetti) nRimetti.addEventListener('click', () => {
    dove.clear(); davanti = 1; disegna();
  });

  /* ============================================================
     SPOSTARE UN CAPO SULLA TAVOLA
     Pointer Events: la stessa riga di codice vale per il dito, il
     mouse e la penna. setPointerCapture tiene il capo agganciato anche
     se il dito esce dalla tavola mentre si trascina.
     ============================================================ */
  if(tavola){
    let preso = null;

    tavola.addEventListener('pointerdown', e => {
      if(e.target.closest('.togli')) return;    /* la crocetta non trascina */
      const posto = e.target.closest('.posto');
      if(!posto) return;
      const h = posto.dataset.handle;
      const d = dove.get(h);
      if(!d) return;

      const r = tavola.getBoundingClientRect();
      preso = {
        posto, h, r,
        /* di quanto il dito e' lontano dall'angolo del capo, in
           percentuale: senza questo il capo salta col suo angolo
           sotto il dito */
        dx: (e.clientX - r.left) / r.width  * 100 - d.l,
        dy: (e.clientY - r.top)  / r.height * 100 - d.t,
      };
      d.z = ++davanti;                          /* quello che tocchi viene davanti */
      posto.style.zIndex = d.z;
      posto.classList.add('trascina');
      posto.setPointerCapture(e.pointerId);
    });

    tavola.addEventListener('pointermove', e => {
      if(!preso) return;
      const d = dove.get(preso.h);
      let l = (e.clientX - preso.r.left) / preso.r.width  * 100 - preso.dx;
      let t = (e.clientY - preso.r.top)  / preso.r.height * 100 - preso.dy;
      /* non si esce dalla tavola: si lascia sempre un quarto del capo
         dentro, altrimenti si puo' perdere un capo oltre il bordo e
         non recuperarlo */
      l = Math.min(100 - d.w/4, Math.max(-d.w*0.75, l));
      t = Math.min(100 - d.h/4, Math.max(-d.h*0.75, t));
      d.l = l; d.t = t;
      preso.posto.style.left = l + '%';
      preso.posto.style.top  = t + '%';
    });

    const molla = e => {
      if(!preso) return;
      preso.posto.classList.remove('trascina');
      try{ preso.posto.releasePointerCapture(e.pointerId); }catch(_){}
      preso = null;
    };
    tavola.addEventListener('pointerup', molla);
    tavola.addEventListener('pointercancel', molla);
  }

  /* ============================================================
     IL FOGLIO DELLE TAGLIE
     Una riga per capo. La cliente puo' prendere anche solo alcuni
     capi del look: va nel carrello chi ha la taglia scelta, gli altri
     restano fuori. Un capo con la sola taglia unica parte gia' scelto,
     ma si toglie toccandolo di nuovo (come ogni taglia scelta). Le
     taglie finite restano visibili e barrate.
     ============================================================ */
  const foglio = radice.querySelector('[data-foglio-look]');
  const velo   = document.querySelector('.velo');
  const taglieScelte = new Map();            /* handle -> id della variante */
  let inFoglio = [];                         /* i capi di cui si stanno chiedendo le taglie */
  let ultimoComando = null;

  const dimentica = h => taglieScelte.delete(h);
  const soloUnica  = c => c.t.length === 1 && c.t[0].e === 'Taglia unica';
  const tutteFinite = c => c.t.every(v => !v.d);

  function riga(h){
    const c = CAPI[h];
    if(!c) return '';
    const finito = tutteFinite(c);

    let scelta;
    if(finito){
      scelta = '<p class="riga-taglia__unica">Esaurito in tutte le taglie</p>' +
               '<button class="riga-taglia__togli" type="button" data-togli-look="' + h + '">Togli dal look</button>';
    } else {
      scelta = '<div class="riga-taglia__taglie">' +
        c.t.map(v =>
          '<button class="taglia" type="button" data-capo="' + h + '" data-variante="' + v.i + '"' +
          ' data-rimaste="' + v.q + '"' + (v.d ? '' : ' disabled aria-disabled="true"') +
          ' aria-pressed="' + (taglieScelte.get(h) === v.i) + '">' + v.e + '</button>').join('') +
        '</div><p class="riga-taglia__resta" data-resta="' + h + '"></p>';
    }

    return '<div class="riga-taglia' + (finito ? ' riga-taglia--finito' : '') + '">' +
      '<img src="' + (c.m || '') + '" alt="">' +
      '<div><div class="riga-taglia__nome">' + c.n + '</div>' +
      (c.c ? '<div class="riga-taglia__colore">' + c.c + '</div>' : '') +
      '<div class="riga-taglia__prezzo">' + c.p + '</div>' + scelta + '</div></div>';
  }

  /* quante ne restano, detto solo quando sono poche: "restano 2" su una
     giacenza di 19 non aiuta, su una di 2 fa decidere */
  function avvisa(h){
    const p = foglio.querySelector('[data-resta="' + h + '"]');
    if(!p) return;
    const id = taglieScelte.get(h);
    const v = CAPI[h].t.find(x => x.i === id);
    const q = v ? v.q : 0;
    p.textContent = q === 1 ? 'Ultimo pezzo' : (q > 0 && q <= 3) ? 'Ne restano ' + q : '';
  }

  function conta(){
    const pronti   = inFoglio.filter(h => taglieScelte.has(h));
    const tot = pronti.reduce((s, h) => s + CAPI[h].pn, 0);
    /* niente conteggio dei capi lasciati fuori (Andrea, 02/10/2026):
       la riga serve solo per l'errore dell'aggiunta */
    const manca = foglio.querySelector('[data-fl-manca]');
    if(manca) manca.textContent = '';
    const b = foglio.querySelector('[data-fl-aggiungi]');
    b.disabled = pronti.length === 0;
    b.textContent = pronti.length === 0 ? 'Aggiungi al carrello'
      : 'Aggiungi ' + pronti.length + (pronti.length === 1 ? ' capo' : ' capi') + ' \u2014 ' + soldi(tot);
  }

  function ridisegna(){
    foglio.querySelector('[data-fl-righe]').innerHTML = inFoglio.map(riga).join('');
    inFoglio.forEach(h => { if(taglieScelte.has(h)) avvisa(h); });
    conta();
  }

  function apriFoglio(handles, comando){
    inFoglio = handles.filter(h => CAPI[h]);
    if(!inFoglio.length) return;
    inFoglio.forEach(h => {
      const c = CAPI[h];
      if(soloUnica(c) && !tutteFinite(c) && !taglieScelte.has(h)) taglieScelte.set(h, c.t[0].i);
    });
    ultimoComando = comando || null;
    ridisegna();
    foglio.removeAttribute('inert');
    foglio.classList.add('aperto');
    if(velo) velo.classList.add('aperto');
    foglio.focus();
  }

  function chiudiFoglio(){
    foglio.classList.remove('aperto');
    if(velo) velo.classList.remove('aperto');
    foglio.setAttribute('inert', '');
    if(ultimoComando) ultimoComando.focus();
  }

  if(foglio){
    foglio.addEventListener('click', e => {
      const t = e.target.closest('.taglia');
      if(t && !t.disabled){
        const h = t.dataset.capo;
        /* toccare la taglia gia' scelta la toglie: il capo resta fuori */
        const via = t.getAttribute('aria-pressed') === 'true';
        if(via) taglieScelte.delete(h); else taglieScelte.set(h, Number(t.dataset.variante));
        t.parentElement.querySelectorAll('.taglia').forEach(x =>
          x.setAttribute('aria-pressed', String(!via && x === t)));
        avvisa(h);
        conta();
        return;
      }
      const via = e.target.closest('[data-togli-look]');
      if(via){
        const h = via.dataset.togliLook;
        dimentica(h);
        inFoglio = inFoglio.filter(x => x !== h);
        if(scelti.includes(h)) commuta(h);     /* lo toglie anche dalla tavola */
        if(!inFoglio.length) chiudiFoglio(); else ridisegna();
      }
    });

    foglio.querySelectorAll('[data-fl-chiudi]').forEach(b =>
      b.addEventListener('click', chiudiFoglio));
    if(velo) velo.addEventListener('click', () => {
      if(foglio.classList.contains('aperto')) chiudiFoglio();
    });
    addEventListener('keydown', e => {
      if(e.key === 'Escape' && foglio.classList.contains('aperto')) chiudiFoglio();
    });

    /* ---------- l'aggiunta al carrello ---------- */
    const aggiungi = foglio.querySelector('[data-fl-aggiungi]');
    aggiungi.addEventListener('click', async () => {
      /* _look: da quale look arriva il capo. E' una proprieta' nascosta
         (il trattino basso la toglie dalla vista in carrello e checkout)
         che l'ordine si porta dietro: SEMPLIFY ci conta ordini e incasso
         per look. "componi-il-tuo" = la tavola composta dalla cliente. */
      const scheda = ultimoComando && ultimoComando.closest('[data-look-scheda]');
      const daLook = scheda ? (scheda.dataset.lookHandle || '')
                   : (ultimoComando && ultimoComando.matches('[data-aggiungi-tutto]') ? 'componi-il-tuo' : '');
      const items = inFoglio.filter(h => taglieScelte.has(h))
                            .map(h => daLook
                              ? { id: taglieScelte.get(h), quantity: 1, properties: { _look: daLook } }
                              : { id: taglieScelte.get(h), quantity: 1 });
      if(!items.length) return;
      const etichetta = aggiungi.textContent;
      aggiungi.disabled = true;
      aggiungi.textContent = 'Aggiungo\u2026';
      try{
        const r = await fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items })
        });
        if(!r.ok){
          const errore = await r.json().catch(() => null);
          throw new Error(errore && errore.description ? errore.description : 'errore');
        }
        await window.bulierAggiornaCarrello();
        if(window.bulierEvento) window.bulierEvento('look_aggiunto_carrello', { look: daLook, capi: items.length });
        aggiungi.textContent = 'Aggiunto';
        /* la tavola si svuota: il look e' nel carrello, ricominciare da
           capo e' piu' chiaro che trovarselo ancora li' */
        setTimeout(() => {
          chiudiFoglio();
          if(inFoglio.some(h => scelti.includes(h))){
            scelti.length = 0; dove.clear(); davanti = 1; taglieScelte.clear(); disegna();
          }
        }, 700);
      }catch(err){
        aggiungi.disabled = false;
        aggiungi.textContent = etichetta;
        const manca = foglio.querySelector('[data-fl-manca]');
        if(manca) manca.textContent = 'Non sono riuscito ad aggiungerli. Riprova.';
      }
    });
  }

  /* ---------- i due pulsanti che aprono il foglio ---------- */
  radice.addEventListener('click', e => {
    const b = e.target.closest('[data-look-aggiungi]');
    if(b){ apriFoglio(b.dataset.lookAggiungi.split(',').filter(Boolean), b); return; }
    const t = e.target.closest('[data-aggiungi-tutto]');
    if(t) apriFoglio(scelti.slice(), t);
  });

  disegna();
})();

/* ============================================================
   LA GUIDA ALLE TAGLIE SULLA SCHEDA PRODOTTO
   Si apre nel foglio che c'e' gia' — lo stesso del selettore
   rapido — invece di portare via dal capo che si sta guardando.
   Chi e' indeciso sulla taglia sta decidendo se comprare: farlo
   uscire dalla scheda in quel momento e' il modo migliore per
   perderlo.

   Il link resta un link vero a una pagina vera: se il JavaScript
   non parte, la guida si apre lo stesso.
   ============================================================ */
(function(){
  const foglio = document.getElementById('bulierFoglio');
  const velo   = document.querySelector('.velo');
  if(!foglio) return;

  let ultimo = null;

  function chiudi(){
    foglio.classList.remove('aperto');
    foglio.setAttribute('inert','');
    if(velo) velo.classList.remove('aperto');
    document.body.style.overflow = '';
    if(ultimo) ultimo.focus();
  }

  document.addEventListener('click', async e => {
    const a = e.target.closest('[data-guida]');
    if(!a) return;
    e.preventDefault();
    ultimo = a;

    foglio.innerHTML = '<div class="foglio__carico">Un momento&hellip;</div>';
    foglio.classList.add('aperto');
    foglio.removeAttribute('inert');
    if(velo) velo.classList.add('aperto');
    document.body.style.overflow = 'hidden';
    foglio.focus();

    try{
      const r = await fetch('/products/' + a.getAttribute('data-guida') + '?section_id=bulier-guida-taglie');
      if(!r.ok) throw new Error(r.status);
      foglio.innerHTML = await r.text();
      foglio.querySelectorAll('[data-guida-chiudi]').forEach(b =>
        b.addEventListener('click', chiudi));
    }catch(err){
      /* se non si riesce a caricare, si va dove si sarebbe andati
         senza JavaScript: la pagina delle taglie */
      location.href = a.getAttribute('href');
    }
  });
})();
